import { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { type ILogbook } from "src/interfaces";

import { useGroupContext } from "../GroupContext";
import { LogbookItemContainer } from "./LogbookItem.styled";
import { type Position } from "./LogbooksSelector";

interface Props {
  logbook: ILogbook;
  targetPosition?: Position;
}

const LogbookItem = ({ logbook, targetPosition }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const { selectedElement, handleMoveLogbook } = useGroupContext();
  useLayoutEffect(() => {
    if (ref.current) {
      const data = ref.current.getBoundingClientRect();
      setPosition({ x: data.x, y: data.y });
    }
  }, [targetPosition]);

  const handleMouseDown = () => {
    if (!selectedElement || !targetPosition) {
      return;
    }

    let itemx = 0;
    let itemy = 0;
    let itemwidth = 0;
    let itemheight = 0;
    if (ref.current) {
      const { x, y, width, height } = ref.current.getBoundingClientRect();
      itemx = x;
      itemy = y;
      itemwidth = width;
      itemheight = height;
    }

    setIsDragging(true);
    setPosition({ x: itemx, y: itemy });

    const handleMouseMove = (event: any) => {
      const newX = event.clientX - itemwidth * 0.5;
      const newY = event.clientY - itemheight * 0.5;

      if (
        newX >= 0 &&
        newY >= 0 &&
        newX + itemwidth <= window.innerWidth &&
        newY + itemheight <= window.innerHeight
      ) {
        setPosition({ x: newX, y: newY });
      }
    };

    const handleMouseUp = (event: any) => {
      setIsDragging(false);

      if (
        targetPosition.x < event.clientX &&
        targetPosition.x + targetPosition.width > event.clientX &&
        targetPosition.y < event.clientY &&
        targetPosition.y + targetPosition.height > event.clientY
      ) {
        handleMoveLogbook(logbook);
      }
      setPosition({ x: itemx, y: itemy });
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <>
      <LogbookItemContainer ref={ref} onMouseDown={handleMouseDown}>
        {logbook?.lbname}
      </LogbookItemContainer>
      {isDragging &&
        createPortal(
          <LogbookItemContainer
            style={{
              position: "absolute",
              top: position.y,
              left: position.x,
              width: 300,
            }}>
            {logbook?.lbname}
          </LogbookItemContainer>,
          document.body,
        )}
    </>
  );
};

export default LogbookItem;
